
import Vue from "vue";
import delCom from "@/components/DelDataCom.vue";
import action from "@/components/ActionBarCom.vue";
import addrCom from "@/components/AddrCom.vue";
import dialogCom from "@/components/ModelCom.vue";
import OrderRequestBill from "@/assets/js/Bill/OrderRequestBill";
import Urls from "@/assets/js/Urls";
import HttpUtil from "@/assets/js/HttpUtil";
import pageCom from "@/components/PageCom.vue";
import Utils from "@/assets/js/Utils";
export default Vue.extend({
  components: { action, addrCom, dialogCom, delCom, pageCom },
  data() {
    return {
      items: [] as any[],
      total: 0 as number,
      pageSize: Utils.getDefalutPageSize(),
      currentPage: 1,
      searchStr: null as any,
      dialogTitle: "新增资产",
      form: {
        sid: "",
        lat: 0,
        lng: 0,
        address: "",
        assetName: "",
        assetTypeSid: "",
        vendor: "勤上光电",
        productionDate: "2026-08-05T09:28:38.670Z",
        serial: "",
      } as any,
      current: null as any,
      assetTypes: [] as any[],
      currentSid: "",
      delUrl: Urls.DeleteAssets,
    };
  },
  mounted() {
    this.select();
  },
  methods: {
    opened() {
      setTimeout(() => {
        const addr: any = this.$refs.addr;
        if (!this.current) {
          addr.init(null);
        } else {
          addr.init({
            addr: this.current.address,
            lat: this.current.lat,
            lng: this.current.lng,
          });
        }
      }, 2000);
    },
    closeDialog() {
      const dialog: any = this.$refs.editDialog;
      dialog.hiden();
    },
    async getAssetTypes() {
      const obj = {
        page: 0,
        pageSize: 100,
      };
      var req: any = await HttpUtil.XCHttpPost(Urls.GetAssetTypes, obj, true, false);
      this.assetTypes = req.data;
    },
    async select() {
      const actionBar: any = this.$refs.action;
      const content = actionBar.getSearch();
      const ret = await OrderRequestBill.GetOrderTypes(
        content,
        this.currentPage,
        this.pageSize
      );
      this.items = ret.data;
      this.total = ret.total;
    },
    search() {
      this.select();
    },
    currentChange(val: any) {
      this.current = val;
    },
    handleSelectionChange() {
      //
    },
    insert() {
      this.form.sid = null;
      const dialog: any = this.$refs.editDialog;
      dialog.show();
    },
    modify() {
      if (!this.current) {
        throw "请选择一条数据";
      }
      this.form = this.current;
      const dialog: any = this.$refs.editDialog;
      dialog.show();
    },
    del() {
      if (!this.current) {
        throw "请选择一条数据";
      }
      this.currentSid = this.current.sid;

      const dialog: any = this.$refs.del;
      dialog.show();
    },
    async asyncDev() {
      await HttpUtil.XCHttpPost(Urls.AsyncDeviceAssets, "", true, false);
    },
    change(val: number, size: number) {
      this.currentPage = val;
      this.pageSize = size;
      this.select();
    },
    onSubmit() {
      const addr: any = this.$refs.addr;
      const data: any = addr.getData();
      this.form.address = data.addr;
      this.form.lat = data.lat;
      this.form.lng = data.lng;
      if (this.form.sid) {
        HttpUtil.XCHttpPost(Urls.UpdateAssets, this.form, true, false);
      } else {
        HttpUtil.XCHttpPost(Urls.InsertAssets, this.form, true, false);
      }
      this.closeDialog();
      this.select();
    },
  },
});
